import { Button } from 'antd-v5';
import React from 'react';

const NewNavBanner = ({ newNav, handleNewNav, onLearnMore, loading }) => {

  return (
    <div className="w-100-P h-54 flex-row-nospacebetween-nowrap" style={{background: "#D6E4FF" }}>
      {newNav ? (
        <>
        <Button type="primary" className='m-left-23' onClick={() => handleNewNav(false)} loading={loading}>
          Change it back
          </Button>
          <a target='_blank' href="https://forms.gle/UCaLYMhca5q5Kk5e8">
            <Button type="primary" className='m-left-15' ghost>
              Submit feedback
            </Button>
          </a>
        </>
      ) : (
        <>
          <Button type="primary" className='m-left-23' onClick={() => handleNewNav(true)} loading={loading}>
            Try it
          </Button>
          <p className='m-left-15 m-right-20 fw-500' style={{ color: "#1677FF" }}>
            We're introducing a new, simpler navigation!
          </p>
          <Button type='link' onClick={onLearnMore}>
            Learn more
          </Button>
        </>
      )}
    </div>
  )

}

export default NewNavBanner;
